export const mockEmployeeAssets = [
  {
    uuid: "asset-001",
    organization_uuid: "org-001",
    employee_uuid: "emp-001",
    asset_type: "Laptop",
    asset_name: "Enterprise Laptop Pro",
    asset_code: "AST-LAP-1001",
    serial_number: "SN001X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue laptop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-002",
    organization_uuid: "org-001",
    employee_uuid: "emp-002",
    asset_type: "Desktop",
    asset_name: "Enterprise Desktop Pro",
    asset_code: "AST-DES-1002",
    serial_number: "SN002X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue desktop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-003",
    organization_uuid: "org-001",
    employee_uuid: "emp-003",
    asset_type: "Monitor",
    asset_name: "Enterprise Monitor Pro",
    asset_code: "AST-MON-1003",
    serial_number: "SN003X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue monitor for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-004",
    organization_uuid: "org-001",
    employee_uuid: "emp-004",
    asset_type: "Phone",
    asset_name: "Enterprise Phone Pro",
    asset_code: "AST-PHO-1004",
    serial_number: "SN004X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue phone for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-005",
    organization_uuid: "org-001",
    employee_uuid: "emp-005",
    asset_type: "Keyboard",
    asset_name: "Enterprise Keyboard Pro",
    asset_code: "AST-KEY-1005",
    serial_number: "SN005X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue keyboard for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-006",
    organization_uuid: "org-001",
    employee_uuid: "emp-006",
    asset_type: "Mouse",
    asset_name: "Enterprise Mouse Pro",
    asset_code: "AST-MOU-1006",
    serial_number: "SN006X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue mouse for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-007",
    organization_uuid: "org-001",
    employee_uuid: "emp-007",
    asset_type: "Headset",
    asset_name: "Enterprise Headset Pro",
    asset_code: "AST-HEA-1007",
    serial_number: "SN007X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue headset for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-008",
    organization_uuid: "org-001",
    employee_uuid: "emp-008",
    asset_type: "Dock",
    asset_name: "Enterprise Dock Pro",
    asset_code: "AST-DOC-1008",
    serial_number: "SN008X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue dock for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-009",
    organization_uuid: "org-001",
    employee_uuid: "emp-009",
    asset_type: "Printer",
    asset_name: "Enterprise Printer Pro",
    asset_code: "AST-PRI-1009",
    serial_number: "SN009X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue printer for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-010",
    organization_uuid: "org-001",
    employee_uuid: "emp-010",
    asset_type: "Laptop",
    asset_name: "Enterprise Laptop Pro",
    asset_code: "AST-LAP-1010",
    serial_number: "SN010X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue laptop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-011",
    organization_uuid: "org-001",
    employee_uuid: "emp-011",
    asset_type: "Desktop",
    asset_name: "Enterprise Desktop Pro",
    asset_code: "AST-DES-1011",
    serial_number: "SN011X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue desktop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-012",
    organization_uuid: "org-001",
    employee_uuid: "emp-012",
    asset_type: "Monitor",
    asset_name: "Enterprise Monitor Pro",
    asset_code: "AST-MON-1012",
    serial_number: "SN012X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue monitor for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-013",
    organization_uuid: "org-001",
    employee_uuid: "emp-013",
    asset_type: "Phone",
    asset_name: "Enterprise Phone Pro",
    asset_code: "AST-PHO-1013",
    serial_number: "SN013X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue phone for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-014",
    organization_uuid: "org-001",
    employee_uuid: "emp-014",
    asset_type: "Keyboard",
    asset_name: "Enterprise Keyboard Pro",
    asset_code: "AST-KEY-1014",
    serial_number: "SN014X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue keyboard for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-015",
    organization_uuid: "org-001",
    employee_uuid: "emp-015",
    asset_type: "Mouse",
    asset_name: "Enterprise Mouse Pro",
    asset_code: "AST-MOU-1015",
    serial_number: "SN015X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue mouse for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-016",
    organization_uuid: "org-001",
    employee_uuid: "emp-016",
    asset_type: "Headset",
    asset_name: "Enterprise Headset Pro",
    asset_code: "AST-HEA-1016",
    serial_number: "SN016X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue headset for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-017",
    organization_uuid: "org-001",
    employee_uuid: "emp-017",
    asset_type: "Dock",
    asset_name: "Enterprise Dock Pro",
    asset_code: "AST-DOC-1017",
    serial_number: "SN017X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue dock for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-018",
    organization_uuid: "org-001",
    employee_uuid: "emp-018",
    asset_type: "Printer",
    asset_name: "Enterprise Printer Pro",
    asset_code: "AST-PRI-1018",
    serial_number: "SN018X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue printer for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-019",
    organization_uuid: "org-001",
    employee_uuid: "emp-019",
    asset_type: "Laptop",
    asset_name: "Enterprise Laptop Pro",
    asset_code: "AST-LAP-1019",
    serial_number: "SN019X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue laptop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-020",
    organization_uuid: "org-001",
    employee_uuid: "emp-020",
    asset_type: "Desktop",
    asset_name: "Enterprise Desktop Pro",
    asset_code: "AST-DES-1020",
    serial_number: "SN020X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue desktop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-021",
    organization_uuid: "org-001",
    employee_uuid: "emp-021",
    asset_type: "Monitor",
    asset_name: "Enterprise Monitor Pro",
    asset_code: "AST-MON-1021",
    serial_number: "SN021X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue monitor for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-022",
    organization_uuid: "org-001",
    employee_uuid: "emp-022",
    asset_type: "Phone",
    asset_name: "Enterprise Phone Pro",
    asset_code: "AST-PHO-1022",
    serial_number: "SN022X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue phone for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-023",
    organization_uuid: "org-001",
    employee_uuid: "emp-023",
    asset_type: "Keyboard",
    asset_name: "Enterprise Keyboard Pro",
    asset_code: "AST-KEY-1023",
    serial_number: "SN023X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue keyboard for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-024",
    organization_uuid: "org-001",
    employee_uuid: "emp-024",
    asset_type: "Mouse",
    asset_name: "Enterprise Mouse Pro",
    asset_code: "AST-MOU-1024",
    serial_number: "SN024X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue mouse for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-025",
    organization_uuid: "org-001",
    employee_uuid: "emp-025",
    asset_type: "Headset",
    asset_name: "Enterprise Headset Pro",
    asset_code: "AST-HEA-1025",
    serial_number: "SN025X89",
    assigned_at: "2026-01-15T09:00:00.000Z",
    returned_at: null,
    status: "Assigned",
    remarks: "Standard issue headset for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-026",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Dock",
    asset_name: "Enterprise Dock Pro",
    asset_code: "AST-DOC-1026",
    serial_number: "SN026X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue dock for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-027",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Printer",
    asset_name: "Enterprise Printer Pro",
    asset_code: "AST-PRI-1027",
    serial_number: "SN027X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue printer for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-028",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Laptop",
    asset_name: "Enterprise Laptop Pro",
    asset_code: "AST-LAP-1028",
    serial_number: "SN028X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue laptop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-029",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Desktop",
    asset_name: "Enterprise Desktop Pro",
    asset_code: "AST-DES-1029",
    serial_number: "SN029X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue desktop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-030",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Monitor",
    asset_name: "Enterprise Monitor Pro",
    asset_code: "AST-MON-1030",
    serial_number: "SN030X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue monitor for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-031",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Phone",
    asset_name: "Enterprise Phone Pro",
    asset_code: "AST-PHO-1031",
    serial_number: "SN031X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue phone for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-032",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Keyboard",
    asset_name: "Enterprise Keyboard Pro",
    asset_code: "AST-KEY-1032",
    serial_number: "SN032X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue keyboard for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-033",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Mouse",
    asset_name: "Enterprise Mouse Pro",
    asset_code: "AST-MOU-1033",
    serial_number: "SN033X89",
    assigned_at: null,
    returned_at: null,
    status: "Available",
    remarks: "Standard issue mouse for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-034",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Headset",
    asset_name: "Enterprise Headset Pro",
    asset_code: "AST-HEA-1034",
    serial_number: "SN034X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Under Repair",
    remarks: "Standard issue headset for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-035",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Dock",
    asset_name: "Enterprise Dock Pro",
    asset_code: "AST-DOC-1035",
    serial_number: "SN035X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Under Repair",
    remarks: "Standard issue dock for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-036",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Printer",
    asset_name: "Enterprise Printer Pro",
    asset_code: "AST-PRI-1036",
    serial_number: "SN036X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Under Repair",
    remarks: "Standard issue printer for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-037",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Laptop",
    asset_name: "Enterprise Laptop Pro",
    asset_code: "AST-LAP-1037",
    serial_number: "SN037X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Lost",
    remarks: "Standard issue laptop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-038",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Desktop",
    asset_name: "Enterprise Desktop Pro",
    asset_code: "AST-DES-1038",
    serial_number: "SN038X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Lost",
    remarks: "Standard issue desktop for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-039",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Monitor",
    asset_name: "Enterprise Monitor Pro",
    asset_code: "AST-MON-1039",
    serial_number: "SN039X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Disposed",
    remarks: "Standard issue monitor for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  },
  {
    uuid: "asset-040",
    organization_uuid: "org-001",
    employee_uuid: null,
    asset_type: "Phone",
    asset_name: "Enterprise Phone Pro",
    asset_code: "AST-PHO-1040",
    serial_number: "SN040X89",
    assigned_at: null,
    returned_at: "2026-05-10T16:00:00.000Z",
    status: "Disposed",
    remarks: "Standard issue phone for corporate use.",
    created_at: "2025-08-01T10:00:00.000Z",
    updated_at: "2026-06-01T10:00:00.000Z"
  }
];